<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    stroke="#000000"
    :stroke-width="iconStroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="icon"
    :class="[name,iconClass]"
  >
    
    <g v-html="iconGraphic"></g>
    
  </svg>
</template>

<script>
  export default {
    props: {
      'name': {
        'type': String,
        'required': false,
        'default': 'ui-chevron-right',
      },
      'color': {
        'type': String,
        'required': false,
        'default': 'black',
      },
      'size': {
        'type': Number,
        'required': false,
        'default': 20,
      },
      'stroke': {
        'type': Number,
        'required': false,
        'default': 2,
      },
      'animated': {
        'type': Boolean,
        'required': false,
        'default': false,
      }
    },
    computed: {
      iconClass() {
        return 'svg-'+this.color; 
      },
      iconStroke() {
        // Resize stroke width so that it is scaleabe with actual font size. This will keep all stroke widths consistent.
        return (this.stroke / this.size) * 20;
      },
      iconGraphic() {
        var i = '';
        
        switch(this.name) {
          case 'icon-add': 
            i = '<path class="svg-stroke stroke-1" d="M14.5,18h-9C3.6,18,2,16.4,2,14.5v-9C2,3.6,3.6,2,5.5,2h9.1C16.4,2,18,3.6,18,5.5v9.1C18,16.4,16.4,18,14.5,18z" /><line class="svg-stroke stroke-2" x1="14" y1="10" x2="6" y2="10" /><line class="svg-stroke stroke-3" x1="10" y1="14" x2="10" y2="6" />';
            break;
            
          case 'icon-beaker':
            i = '<polyline class="svg-stroke stroke-1" points="7,1 7,10 2,19 18,19 13,10 13,1 "/><line class="svg-stroke stroke-2" x1="14" y1="1" x2="6" y2="1"/><line class="svg-stroke stroke-3" x1="10" y1="13" x2="14.7" y2="13"/>';
            break;
            
          case 'icon-bin':
            i = '<path class="svg-stroke stroke-1" d="M3,5l0.9,12.4C4,18.3,4.7,19,5.6,19h8.8c0.9,0,1.6-0.7,1.7-1.6L17,5"/><path class="svg-stroke stroke-2" d="M7,5V2.2C7,1.6,7.6,1,8.2,1h3.5C12.4,1,13,1.6,13,2.2V5"/><line class="svg-stroke stroke-3" x1="1" y1="5" x2="19" y2="5"/><line class="svg-stroke stroke-4" x1="8" y1="9" x2="8" y2="15"/><line class="svg-stroke stroke-5" x1="12" y1="9" x2="12" y2="15"/>';
            break;
            
          case 'icon-bubble':
            i = '<line class="svg-stroke stroke-1" x1="10" y1="8" x2="10" y2="8"/><line class="svg-stroke stroke-2" x1="14" y1="8" x2="14" y2="8"/><line class="svg-stroke stroke-3" x1="6" y1="8" x2="6" y2="8"/><path class="svg-stroke stroke-4" d="M16.3,1H3.7C2.2,1,1,2.2,1,3.7v8.6C1,13.8,2.2,15,3.7,15H15l4,4V3.7C19,2.2,17.8,1,16.3,1z"/>';
            break;
            
          case 'icon-calculator':
            i = '<path class="svg-stroke stroke-1" d="M13.8,19H6.2C4.4,19,3,17.6,3,15.8V4.2C3,2.4,4.4,1,6.2,1h7.7C15.6,1,17,2.4,17,4.2v11.7 C17,17.6,15.6,19,13.8,19z"/><polyline class="svg-stroke stroke-2" points="13,7 7,7 7,5 "/><line class="svg-stroke stroke-3" x1="8" y1="11" x2="7" y2="11"/><line class="svg-stroke stroke-4" x1="12" y1="11" x2="13" y2="11"/><line class="svg-stroke stroke-5" x1="8" y1="15" x2="7" y2="15"/><line class="svg-stroke stroke-6" x1="13" y1="15" x2="12" y2="15"/>';
            break;

          case 'icon-carbon-element':
            i = '<path class="svg-stroke stroke-1" d="M15,18H5c-1.7,0-3-1.4-3-3V5c0-1.7,1.3-3,3-3h10c1.6,0,3,1.3,3,3v10C18,16.6,16.6,18,15,18z"/><path class="svg-stroke stroke-2" d="M13,12.7c-1.5,1.5-3.9,1.5-5.3,0s-1.5-3.9,0-5.3s3.9-1.5,5.3,0"/>';
            break;
          
          case 'icon-carbon-sample':
            i = '<ellipse class="svg-stroke stroke-1" cx="10" cy="4.5" rx="6" ry="2.5"/><path class="svg-stroke stroke-2" d="M4,4.5v11c0,1.4,2.7,2.5,6,2.5s6-1.1,6-2.5v-11"/><path class="svg-stroke stroke-3" d="M16,11c0,1.7-2.7,3-6,3c-0.7,0-1.4-0.1-2-0.2"/>';
            break;

          case 'icon-carbon-tick':
            i = '<path class="svg-stroke stroke-1" d="M14.9,14.9c-2.7,2.7-7.2,2.7-9.9,0s-2.7-7.2,0-9.9c2.3-2.3,5.8-2.7,8.4-1.1"/><path class="svg-stroke stroke-2" d="M19,4l-8.5,8L8,9.4"/>';
            break;
            
          case 'icon-checkbox':
            i = '<path class="svg-stroke stroke-1" d="M17,4v11.1c0,1.6-1.3,2.9-2.9,2.9H4.9C3.3,18,2,16.7,2,15.1V5.9C2,4.3,3.3,3,4.9,3H12"/><polyline class="svg-stroke stroke-2" points="19,2 9,12 6,9 "/>';
            break;
            
          case 'icon-clock':
            i = '<circle class="svg-stroke stroke-1" cx="10" cy="10" r="9"/><polyline class="svg-stroke stroke-2" points="10,6 10,10 13,13 "/>';
            break;
            
          case 'icon-cog':
            i = '<path class="svg-stroke stroke-1" d="M17.2,10c0-0.3,0-0.7-0.1-1l1.1-0.9c0.4-0.3,0.5-0.9,0.3-1.3L17,4.2c-0.3-0.4-0.8-0.6-1.3-0.4l-1.3,0.6 c-0.5-0.4-1.1-0.7-1.7-1l-0.2-1.4C12.5,1.4,12,1,11.5,1H8.5C8,1,7.5,1.4,7.5,1.9L7.3,3.3c-0.6,0.3-1.2,0.6-1.7,1L4.2,3.7 c-0.5-0.2-1,0-1.3,0.4L1.4,6.8c-0.3,0.4-0.1,1,0.3,1.3L2.9,9c0,0.3-0.1,0.7-0.1,1c0,0.3,0,0.7,0.1,1l-1.1,0.9 c-0.4,0.3-0.5,0.9-0.3,1.3L3,15.8c0.3,0.4,0.8,0.6,1.3,0.4l1.3-0.6c0.5,0.4,1.1,0.7,1.7,1l0.2,1.4C7.5,18.6,8,19,8.5,19h3.1 c0.5,0,0.9-0.4,1-0.9l0.2-1.4c0.6-0.3,1.2-0.6,1.7-1l1.3,0.6c0.5,0.2,1,0,1.3-0.4l1.5-2.6c0.3-0.4,0.1-1-0.3-1.3L17.1,11 C17.2,10.7,17.2,10.3,17.2,10z"/><circle class="svg-stroke stroke-2" cx="10" cy="10" r="3"/>';
            break;
            
          case 'icon-document':
            i = '<polygon class="svg-stroke stroke-1" points="11,1 3,1 3,19 17,19 17,7"/><polyline class="svg-stroke stroke-2" points="11,1 11,7 17,7"/><line class="svg-stroke stroke-3" x1="13" y1="11" x2="7" y2="11"/><line class="svg-stroke stroke-4" x1="13" y1="15" x2="7" y2="15"/>';
            break;
          
          case 'icon-download':
            i = '<polyline class="svg-stroke stroke-1" points="1,13.2 1,19 19,19 19,13.2"/><line class="svg-stroke stroke-2" x1="10" y1="1" x2="10" y2="14"/><polyline class="svg-stroke stroke-3" points="5,9 10,14 15,9"/>';
            break;
            
          case 'icon-edit':
            i = '<line class="svg-stroke stroke-1" x1="2" y1="18" x2="18" y2="18"/><path class="svg-stroke stroke-2" d="M4,12l4,4l9.9-9.9c0.6-0.6,0.6-1.6,0-2.2l-1.8-1.8c-0.6-0.6-1.6-0.6-2.2,0L4,12z"/><polyline class="svg-stroke stroke-3" points="8,16 2,18 4,12 "/><line class="svg-stroke stroke-4" x1="11" y1="5" x2="15" y2="9"/>';
            break;
            
          case 'icon-exchange':
            i = '<polyline class="svg-stroke stroke-1" points="5,1 1,5 5,9"/><polyline class="svg-stroke stroke-2" points="15,19 19,15 15,11"/><line class="svg-stroke stroke-3" x1="1" y1="5" x2="17" y2="5"/><line class="svg-stroke stroke-4" x1="19" y1="15" x2="3" y2="15"/>';
            break;
                        
          case 'icon-filter':
            i = '<path class="svg-stroke stroke-1" d="M17.2,2H2.8c-1.1,0-1.7,1.3-1,2.1L7,10v8l6-3v-5l5.2-5.9C18.9,3.3,18.3,2,17.2,2z"/>';
            break;
            
          case 'icon-folder':
            i = '<polygon class="svg-stroke stroke-1" points="19,17.1 5,17.1 1,9 15,9"/><polyline class="svg-stroke stroke-2" points="19,17.1 19,5 18,3 14,3 13,5 4,5 4,6"/>';
            break;
            
          case 'icon-group':
            i = '<rect class="svg-stroke stroke-1" x="2" y="2" width="6" height="6"/><rect class="svg-stroke stroke-2" x="12" y="2" width="6" height="6"/><rect class="svg-stroke stroke-3" x="2" y="12" width="6" height="6"/><rect class="svg-stroke stroke-4" x="12" y="12" width="6" height="6"/>';
            break;
            
          case 'icon-hand':
            i = '<path class="svg-stroke stroke-1" d="M9,10h2c0.6,0,1.2-0.2,1.8-0.5l2.7-1.8c1.1-0.7,2.3-0.7,3,0.2c0.7,0.9,0.8,2.2-0.5,3.1l-3.7,2.5 c-0.5,0.3-1.1,0.5-1.8,0.5H7c-1,0-1.6,0.6-2,1l-1,1"/><path class="svg-stroke stroke-2" d="M11,10c1,0,2-0.9,2-2s-1-2-2-2H9C7.2,6,6,6,4,8l-3,3"/>';
            break;
            
          case 'icon-layers':
            i = '<polygon class="svg-stroke stroke-1" points="10,1 1,6 10,11 19,6 "/><polyline class="svg-stroke stroke-2" points="4.6,8 1,10 10,15 19,10 15.4,8 "/><polyline class="svg-stroke stroke-3" points="4.6,12 1,14 10,19 19,14 15.4,12 "/>';
            break;
            
          case 'icon-leaf':
            i = '<path class="svg-stroke stroke-1" d="M14.9,15.8c-3,3-7.7,3-10.7,0s-2.9-7.7,0-10.7C8.2,1.2,18,2,18,2S18.8,11.8,14.9,15.8z"/><line class="svg-stroke stroke-2" x1="11.6" y1="8.4" x2="1" y2="19"/>';
            break;
            
          case 'icon-mail':
            i = '<path class="svg-stroke stroke-1" d="M16.7,17H3.3C2,17,1,16,1,14.7V5.3C1,4,2,3,3.3,3h13.4C18,3,19,4,19,5.3v9.4C19,16,18,17,16.7,17z"/><polyline class="svg-stroke stroke-2" points="2,4 10,11 18,4 "/><line class="svg-stroke stroke-3" x1="5" y1="13" x2="8.4" y2="9.6"/><line class="svg-stroke stroke-4" x1="15" y1="13" x2="11.6" y2="9.6"/>';
            break;
            
          case 'icon-more':
            i = '<circle class="svg-stroke stroke-1" cx="10" cy="10" r="9"/><line class="svg-stroke stroke-2" x1="10" y1="10" x2="10" y2="10"/><line class="svg-stroke stroke-3" x1="6" y1="10" x2="6" y2="10"/><line class="svg-stroke stroke-4" x1="14" y1="10" x2="14" y2="10"/>';
            break;
            
          case 'icon-people':
            i = '<circle class="svg-stroke stroke-1" cx="7" cy="6" r="3"/><path class="svg-stroke stroke-2" d="M1,17v-2.3C1,13.2,2.2,12,3.7,12h6.7c1.5,0,2.7,1.2,2.7,2.7V17"/><path class="svg-stroke stroke-3" d="M19,17v-2.3c0-1.5-1.2-2.7-2.7-2.7h-0.8"/><path class="svg-stroke stroke-4" d="M12.5,8.9C12.6,9,12.8,9,13,9c1.7,0,3-1.3,3-3s-1.3-3-3-3c-0.2,0-0.4,0-0.5,0.1"/>';
            break;
            
          case 'icon-percent':
            i = '<path class="svg-stroke stroke-1" d="M14.5,18H5.5C3.6,18,2,16.4,2,14.5V5.5C2,3.6,3.6,2,5.5,2h9.1C16.4,2,18,3.6,18,5.5v9.1 C18,16.4,16.4,18,14.5,18z"/><line class="svg-stroke stroke-2" x1="7" y1="13" x2="13" y2="7"/><line class="svg-stroke stroke-3" x1="7" y1="7" x2="7" y2="7"/><line class="svg-stroke stroke-4" x1="13" y1="13" x2="13" y2="13"/>';
            break;
            
          case 'icon-person':
            i = '<circle class="svg-stroke stroke-1" cx="10" cy="5" r="4"/><path class="svg-stroke stroke-2" d="M1,19v-2c0-2.2,1.8-4,4-4h10c2.2,0,4,1.8,4,4v2"/>';
            break;
            
          case 'icon-phone':
            i = '<path class="svg-stroke stroke-1" d="M13.7,11.3L12,13l0,0c-2-1.3-3.7-3-5-5l0,0l1.7-1.7c0.7-0.7,0.7-2,0-2.7L6.7,1.7C6.3,1.3,5.6,1,5,1h0 C4.4,1,3.7,1.3,3.3,1.7L1.7,3.3C1.3,3.7,1,4.4,1,5v0c0,0.7,0.1,1.3,0.4,1.9l0,0c2.3,5.2,6.5,9.4,11.7,11.7l0,0 c0.6,0.3,1.3,0.4,1.9,0.4h0c0.6,0,1.3-0.3,1.7-0.7l1.6-1.6c0.5-0.5,0.7-1.1,0.7-1.7v0c0-0.6-0.3-1.3-0.7-1.7l-1.9-1.9 C15.6,10.6,14.4,10.6,13.7,11.3z"/>';
            
            if(this.animated){
              i += '<path class="animated-stroke svg-stroke stroke-2" d="M14.8,7.1c-0.4-0.9-1.1-1.6-2-1.9"/><path class="animated-stroke svg-stroke stroke-3" d="M19,9c0-4.4-3.6-8-8-8"/>';
            }
            
            break;
          
          case 'icon-pin':
            i = '<path class="svg-stroke stroke-1" d="M3,8c0-3.9,3.1-7,7-7s7,3.1,7,7c0,5.2-7,11-7,11S3,13.2,3,8z"/><circle class="svg-stroke stroke-2" cx="10" cy="8" r="2"/>';
            break;
            
          case 'icon-play':
            i = '<path class="svg-stroke stroke-1" d="M17,8.3L5,1.3C3.7,0.5,2,1.4,2,3V17c0,1.5,1.7,2.5,3,1.7l12.1-7C18.3,10.9,18.3,9.1,17,8.3z"/><line class="svg-stroke stroke-2" x1="6" y1="6" x2="6" y2="10"/>';
            break;
            
          case 'icon-ribbon':
            i = '<polygon class="svg-stroke stroke-1" points="17,7.5 15.5,9.2 15.7,11.5 13.4,12 12.2,14 10,13.1 7.8,14 6.6,12 4.3,11.5 4.5,9.2 3,7.5 4.5,5.8 4.3,3.5 6.6,3 7.8,1 10,1.9 12.2,1 13.4,3 15.7,3.5 15.5,5.8 "/><polyline class="svg-stroke stroke-2" points="15,11.8 15,19 10,17 5,19 5,11.8 "/>';
            break;
            
          case 'icon-search':
            i = '<circle class="svg-stroke stroke-1" cx="8" cy="8" r="7"/><line class="svg-stroke stroke-2" x1="19" y1="19" x2="13" y2="13"/>';
            break;
            
          case 'icon-shield':
            i = '<path class="svg-stroke stroke-1" d="M2,4v7c0,5.2,8,8,8,8s8-2.8,8-8V4l-8-3L2,4z"/><polyline class="svg-stroke stroke-2" points="10,5.2 6,6.6 6,10"/>';
            break;
            
          case 'icon-shovel':
            i = '<path class="svg-stroke stroke-1" d="M13,4l4.5,4.5c1,1,1.5,2.3,1.5,3.6l0,4.3c0,1.4-1.2,2.6-2.6,2.6l-4.3,0c-1.4,0-2.7-0.5-3.6-1.5L4,13L13,4z"/><line class="svg-stroke stroke-2" x1="1" y1="5" x2="5" y2="1"/><line class="svg-stroke stroke-3" x1="3" y1="3" x2="11" y2="11"/>';
            break;
            
          case 'icon-soil':
            i = '<path class="svg-stroke stroke-1" d="M5.7,6.1L1,17h18L14.3,6.1C12.5,2,7.5,2,5.7,6.1z"/><line class="svg-stroke stroke-2" x1="10.8" y1="8.1" x2="14.6" y2="17"/>';
            break;
            
          case 'icon-star':
            i = '<polygon class="svg-stroke stroke-1" points="10,1.4 12.8,7.1 19,8 14.5,12.4 15.6,18.6 10,15.6 4.4,18.6 5.5,12.4 1,8 7.2,7.1 "/>';
            break;
            
          case 'icon-star-full':
            i = '<polygon class="svg-stroke stroke-1" points="10,1.4 12.8,7.1 19,8 14.5,12.4 15.6,18.6 10,15.6 4.4,18.6 5.5,12.4 1,8 7.2,7.1 "/><polygon class="svg-fill fill-1" points="10,1.4 12.8,7.1 19,8 14.5,12.4 15.6,18.6 10,15.6 4.4,18.6 5.5,12.4 1,8 7.2,7.1 "/>';
            break;
            
          case 'icon-star-half':
            i = 'polygon class="svg-stroke stroke-1" points="10,1.4 12.8,7.1 19,8 14.5,12.4 15.6,18.6 10,15.6 4.4,18.6 5.5,12.4 1,8 7.2,7.1 "/><polygon class="svg-fill fill-1" points="19,8 12.8,7.1 10,1.4 10,15.6 15.6,18.6 14.5,12.4 "/>';
            break;
            
          case 'icon-tag':
            i = '<polygon class="svg-stroke stroke-1" points="5,1 1,5 1,10 10,19 19,10 10,1 "/><line class="svg-stroke stroke-2" x1="1" y1="1" x2="7" y2="7"/><circle class="svg-stroke stroke-3" cx="7" cy="7" r="1"/>';
            break;
            
          case 'icon-test-tube':
            i = '<path class="svg-stroke stroke-1" d="M18.6,3.3l-1.9-1.9c-0.6-0.6-1.5-0.6-2.1,0L1.8,14.2c-1.1,1.1-1.1,2.9,0,3.9c1.1,1.1,2.9,1.1,3.9,0L18.6,5.4 C19.1,4.8,19.1,3.9,18.6,3.3z"/><line class="svg-stroke stroke-2" x1="10.5" y1="3.5" x2="16.5" y2="9.5"/><line class="svg-stroke stroke-3" x1="13.9" y1="10" x2="6.1" y2="10"/>';
            break;
            
          case 'icon-van':
            i = '<polyline class="svg-stroke stroke-1" points="17,14 19,14 19,9 14,4 2,4 2,11 1,11 "/><polyline class="svg-stroke stroke-2" points="11,7 11,9 14,9 "/><circle class="svg-stroke stroke-3" cx="15" cy="14" r="2"/><circle class="svg-stroke stroke-4" cx="6" cy="14" r="2"/><line class="svg-stroke stroke-5" x1="13" y1="14" x2="8" y2="14"/><line class="svg-stroke stroke-6" x1="4" y1="14" x2="1" y2="14"/><line class="svg-stroke stroke-7" x1="2" y1="6.1" x2="1" y2="6.1"/>';
            break;
            
          case 'icon-water':
            i = '<path class="svg-stroke stroke-1" d="M17,12c0,3.8-3.1,7-7,7s-7-3.1-7-7c0-5.2,7-11,7-11S17,6.8,17,12z"/><path class="svg-stroke stroke-2" d="M10,15c-1.7,0-3-1.3-3-3"/>';
            break;
            
          case 'icon-wheat':
            i = '<path class="svg-stroke stroke-1" d="M10,19H6.2C4.5,19,3,17.5,3,15.8V13h3.8c1.8,0,3.2,1.5,3.2,3.2V19z"/><path class="svg-stroke stroke-2" d="M10,19h3.8c1.8,0,3.2-1.5,3.2-3.2V13h-3.8c-1.8,0-3.2,1.5-3.2,3.2V19z"/><path class="svg-stroke stroke-3" d="M10,13H6.2C4.5,13,3,11.5,3,9.8V7h3.8C8.5,7,10,8.5,10,10.2V13z"/><path class="svg-stroke stroke-4" d="M10,13h3.8c1.8,0,3.2-1.5,3.2-3.2V7h-3.8C11.5,7,10,8.5,10,10.2V13z"/><path class="svg-stroke stroke-5" d="M7.3,7c-0.9-0.9-0.9-2.4,0-3.4L10,1l2.7,2.7c0.9,0.9,0.9,2.4,0,3.4"/>';
            break;
            
          case 'social-facebook':
            i = '<path class="svg-fill fill-1" d="M0,0v20h10v-7H7.5v-3H10V8c0-2.6,1.3-4,3.6-4c1.1,0,2.2,0.1,2.4,0.2V7h-1.5C13.3,7,13,7.4,13,8.3V10h2.8L15,13h-2v7h7V0H0z" />';
            break;
            
          case 'social-linkedin':
            i = '<path class="svg-fill fill-1" d="M0,0v20h20V0H0z M3,17V7.5h3V17H3z M4.5,6.3c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8 C6.3,5.5,5.5,6.3,4.5,6.3z M17,17h-3v-4.6c0-1.1,0-2.5-1.5-2.5c-1.4,0-1.5,1.2-1.5,2.4V17H8V7.5h2.8v1.3h0.2 c0.4-0.7,1.2-1.5,2.6-1.5c3,0,3.5,2,3.5,4.5V17z"/>';
            break;
            
          case 'social-twitter':
            i = '<path class="svg-fill fill-1" d="M19.4,2.3c-0.8,0.5-1.7,0.8-2.6,1C16.1,2.5,15,2,13.8,2c-2.3,0-4.1,1.8-4.1,4c0,0.3,0,0.6,0.1,0.9C6.4,6.8,3.4,5.2,1.4,2.7 C1,3.3,0.8,4,0.8,4.8c0,1.4,0.7,2.6,1.8,3.4C2,8.1,1.4,7.9,0.8,7.6c0,0,0,0,0,0.1c0,2,1.4,3.6,3.3,4c-0.3,0.1-0.7,0.1-1.1,0.1 c-0.3,0-0.5,0-0.8-0.1c0.5,1.6,2,2.8,3.8,2.8c-1.4,1.1-3.2,1.7-5.1,1.7c-0.3,0-0.7,0-1-0.1C1.8,17.3,4,18,6.3,18 C13.8,18,18,11.8,18,6.5c0-0.2,0-0.3,0-0.5c0.8-0.6,1.5-1.3,2-2.1c-0.7,0.3-1.5,0.5-2.4,0.6C18.5,4,19.1,3.2,19.4,2.3z"/>';
            break;
            
          case 'ui-arrow-down':
            i = '<polyline class="svg-stroke stroke-1" points="16,11 10,17 4,11 "/><line class="svg-stroke stroke-2" x1="10" y1="17" x2="10" y2="3"/>';
            break;
            
          case 'ui-arrow-left':
            i = '<polyline class="svg-stroke stroke-1" points="9,16 3,10 9,4 "/><line class="svg-stroke stroke-2" x1="3" y1="10" x2="17" y2="10"/>';
            break;
            
          case 'ui-arrow-right':
            i = '<polyline class="svg-stroke stroke-1" points="11,4 17,10 11,16 "/><line class="svg-stroke stroke-2" x1="17" y1="10" x2="3" y2="10"/>';
            break;
            
          case 'ui-arrow-up':
            i = '<polyline class="svg-stroke stroke-1" points="4,9 10,3 16,9 "/><line class="svg-stroke stroke-2" x1="10" y1="3" x2="10" y2="17"/>';
            break;
            
          case 'ui-chevron-down':
            i = '<polyline class="svg-stroke stroke-1" points="16,7 10,13 4,7 "/>';
            break;
            
          case 'ui-chevron-left':
            i = '<polyline class="svg-stroke stroke-1" points="13,16 7,10 13,4 "/>';
            break;
            
          case 'ui-chevron-right':
            i = '<polyline class="svg-stroke stroke-1" points="7,16 13,10 7,4 "/>';
            break;
            
          case 'ui-chevron-up':
            i = '<polyline class="svg-stroke stroke-1" points="4,13 10,7 16,13 "/>';
            break;
            
          case 'ui-cross':
            i = '<line class="svg-stroke stroke-1" x1="5" y1="5" x2="15" y2="15"/><line class="svg-stroke stroke-2" x1="15" y1="5" x2="5" y2="15"/>';
            break;
            
          case 'ui-info':
            i = '<line class="svg-stroke stroke-1" x1="10" y1="9" x2="10" y2="16"/><circle class="svg-stroke stroke-2" cx="10" cy="4.5" r="0.5"/><circle class="svg-fill fill-1" cx="10" cy="4.5" r="0.5"/>';
            break;
            
          case 'ui-minus':
            i = '<line class="svg-stroke stroke-1" x1="4" y1="10" x2="16" y2="10"/>';
            break;
            
          case 'ui-plus':
            i = '<line class="svg-stroke stroke-1" x1="4" y1="10" x2="16" y2="10"/><line class="svg-stroke stroke-2" x1="10" y1="4" x2="10" y2="16"/>';
            break;
            
          case 'ui-tick':
            i = '<polyline class="svg-stroke stroke-1" points="3,11 7,15 17,5 "/>';
            break;
            
          case 'ui-warning':
            i = '<line class="svg-stroke stroke-1" x1="10" y1="11" x2="10" y2="7.5"/><line class="svg-stroke stroke-2" x1="10" y1="14.5" x2="10" y2="14.5"/><path class="svg-stroke stroke-3" d="M8.2,3L1.4,15c-0.8,1.3,0.2,3,1.8,3h13.8c1.6,0,2.5-1.7,1.8-3L11.8,3C11,1.7,9,1.7,8.2,3z"/>';
            break;
          
          default:
            i = '<polyline class="svg-stroke stroke-1" points="7,16 13,10 7,4 "/>';
           
        }
    
        return i;
      }
    }
  }
</script>